import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import { Box } from "@mui/material";

const WhatsUp = () => {
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        marginTop: "1rem",
        gap: 2,
        zIndex: 1000,
        position: "fixed",
        bottom: "1rem",
        right: "1rem",
        textAlign: "center",
      }}
    >
      <a
                       href="https://api.whatsapp.com/send/?phone=4915901600845"
        target="_blank"
        rel="noopener noreferrer"
        className="social-icon"
      >
        <>
          <WhatsAppIcon
            sx={{
              color: "white",
              fontSize: "2.6rem",
              padding: "0.5rem",
              width: "50px",
              height: "50px",
              backgroundColor: "#25d366",
              borderRadius: "50%",
              border: "1px solid #25d366",
              textAlign: "center",
              transition: "0.5s ease-in-out",
            }}
          />
        </>
      </a>
    </Box>
  );
};

export default WhatsUp;
